import axios from 'axios'
import { getRequestConfig } from 'src/queries/requestConfig'

import {
  SendPhoneCodeRequest,
  SendPhoneCodeResponse,
  VerifyPhoneCodeRequest,
  VerifyPhoneCodeResponse,
} from './phoneVerification.models'

export const postSendPhoneCode = async (
  req: SendPhoneCodeRequest,
): Promise<SendPhoneCodeResponse> => {
  const requestConfig = getRequestConfig()

  const response = await axios.post<SendPhoneCodeResponse>(
    '/users/phone/sendcode',
    req,
    requestConfig,
  )
  return response.data
}

export const postVerifyPhoneCode = async (
  req: VerifyPhoneCodeRequest,
): Promise<VerifyPhoneCodeResponse> => {
  const requestConfig = getRequestConfig()

  const response = await axios.post<VerifyPhoneCodeResponse>(
    '/users/phone/verifycode',
    req,
    requestConfig,
  )
  return response.data
}
